import { useEffect, useState } from "react";
import { toast } from "sonner";
import { formatET } from "../../lib/dateUtils";
import { api, formatApiErrorDetail } from "../../lib/api";

export function PendingSignupsPanel() {
  const [pending, setPending] = useState([]);

  const fetchPending = async () => {
    try {
      const { data } = await api.get("/admin/pending-signups");
      setPending(data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  useEffect(() => { fetchPending(); }, []);

  const approve = async (id) => {
    try {
      const { data } = await api.post(`/admin/pending-signups/${id}/approve`);
      toast.success(data.message);
      fetchPending();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  if (pending.length === 0) return null;

  return (
    <div className="bg-igc-surface border border-igc-gold/30 p-5 mb-8" data-testid="pending-signups-panel">
      <h2 className="font-serif text-lg text-igc-cream tracking-tight mb-3" title="People who created an affiliate account on the signup page but haven't been approved into the system yet.">New Affiliate Signups Awaiting Approval</h2>
      <div className="space-y-2">
        {pending.map((p) => (
          <div key={p.id} className="flex items-center justify-between gap-3 flex-wrap bg-igc-surfaceLight border border-igc-gold/15 p-3" data-testid={`pending-signup-row-${p.id}`}>
            <div>
              <p className="text-igc-cream text-sm">{p.display_name} <span className="text-igc-muted text-xs">({p.email})</span></p>
              <p className="text-igc-muted text-xs">Signed up {formatET(p.created_at, "MMM d, yyyy")}</p>
            </div>
            <button data-testid={`pending-signup-approve-${p.id}`} onClick={() => approve(p.id)} title="Approves this signup, creating a full affiliate account so they can log in and start receiving leads." className="text-xs px-3 py-1.5 bg-igc-gold hover:bg-igc-goldHover text-black">Approve</button>
          </div>
        ))}
      </div>
    </div>
  );
}
